import { OrderDetailsUserPermissions } from "../../common/user-permissions/order-details-user-permission";
import OrderDetailsCargoOrder from "../../common/types/order-details-cargo-order";
import OrderDetailsDriver from "../../common/types/order-details-driver";

export enum OrderDetailsToolsPropsStatus {
  CANDIDATURE = "CANDIDATURE",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING = "PENDING",
  PLANNED = "PLANNED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}

type OrderDetailsToolsProps = {
  drivers: OrderDetailsDriver[];
  userPermissions: OrderDetailsUserPermissions;
  isRouteSequenceSolved: boolean;
  cargoOrderDetails: OrderDetailsCargoOrder | null;
  cargoCompanyUuid: string;
  isRouteStarted: boolean;
  isCancelOrderFetching: boolean;
  isCompletedRoutesFetching: boolean;
  isCompletedRouteButtonActive: boolean;
  isCancelOrderRequestFetching: boolean;
  isOptimizerVisible: boolean;
  shouldShowOrderHistory: boolean;
  executionStatus: OrderDetailsToolsPropsStatus | null;
  onOrderAccept: () => void;
  onOrderReject: () => void;
  cancelOrder: () => void;
  onEditTaxiCorporationSuccess: (value: string) => void;
  onAddCandidatureSuccess: () => void;
  onCopyDetailsButtonClick: () => void;
  onEditOrderButtonClick: () => void;
  onOrderHistoryButtonClick: () => void;
  toggleCompletedMapRoutesActive: () => void;
  toggleGoogleMapsRoute: () => void;
  onCargoExternalIdChangeSuccess: () => void;
  onFilteredOrderButtonClick: () => void;
  sendOrderCancellationRequest: () => void;
  sendRevertOrderCancellationRequest: () => void;
};
export default OrderDetailsToolsProps;
